import { jsx as _jsx } from "react/jsx-runtime";
import { RadioGroup } from "@mui/material";
export const UiRadioGroupUncustomized = (props) => _jsx(RadioGroup, Object.assign({}, props));
//# sourceMappingURL=ui_radio_group_uncustomized.js.map